import React from 'react';
import styled from 'styled-components';
import ImagePlaceholder from '../../images/image-placeholder.jpg'
import { TooltipWrapper } from '@prosolve/common-components-ui';

const Card = styled.div`
  display: flex;
  color: #565656;
  font-size: 14px;
`

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 7px;
  margin-top: 2px;
  flex: 1;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 20px;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ProductImage = styled.div`
  margin: auto;
  width: 100px;
  text-align: center;
`

const BigNumber = styled.div`
  color: rgb(2, 128, 198);
  font-size: 24px;

  &.IsGenerated {
    color: rgb(248, 135, 0);
    cursor: help;
  }
`

const CardPopup = styled.div`
  padding: 5px 20px 0 20px;
`

export default ({
  lineItem
}) => {
  const {
    IsGeneratedData,
    Quantity,
    Units_Shipped__c,
    Units_Requested__c,
    Units_Delivered__c,
    Units_Remaining_to_Ship__c,
    PricebookEntry: {
      Product2: {
        Name,
        Product_Image__c,
        Shipbob_SKU_Code__c,
      }
    }
  } = lineItem

  const imageSrc = Product_Image__c || ImagePlaceholder;

  const numHelp = (IsGeneratedData ? 'This value is generated based on other line items and currently cannot track its shipping status. It is currently only used to assist in the generation of orders.': '');

  // TODO these should probably be moved to the backend
  const deliveredOnlyCount = (Units_Delivered__c || 0)
  const shippedOnlyCount = (Units_Shipped__c || 0) - (Units_Delivered__c || 0)
  const requestedOnlyCount = (Units_Requested__c || 0) - (Units_Shipped__c || 0)
  const fulfilled = deliveredOnlyCount + requestedOnlyCount + shippedOnlyCount
  const remainingOnlyCount = Quantity - fulfilled
  const remaining = Units_Remaining_to_Ship__c

  const fulfilledPopup = (
    <CardPopup>
      <Row>
        <Column>
          <div style={{ color: 'rgb(2, 128, 198)', fontSize: '24px' }}>{requestedOnlyCount}</div>
          <div style={{ color: 'gray', fontSize: '12px' }}>Processing</div>
        </Column>
        <Column>
          <div style={{ color: 'rgb(2, 128, 198)', fontSize: '24px' }}>{shippedOnlyCount}</div>
          <div style={{ color: 'gray', fontSize: '12px' }}>Shipped</div>
        </Column>
        <Column>
          <div style={{ color: 'rgb(2, 128, 198)', fontSize: '24px' }}>{deliveredOnlyCount}</div>
          <div style={{ color: 'gray', fontSize: '12px' }}>Delivered</div>
        </Column>
      </Row>
    </CardPopup>
  )

  const remainingPopup = (
    <CardPopup>
      <Row>
        <Column>
          <BigNumber>{remaining}</BigNumber>
          <div style={{ color: 'gray', fontSize: '12px' }}>Salesforce</div>
        </Column>
        <Column>
          <BigNumber>{remainingOnlyCount}</BigNumber>
          <div style={{ color: 'gray', fontSize: '12px' }}>Live&nbsp;Calculation</div>
        </Column>
      </Row>
    </CardPopup>
  )

  return (
    <Card>
      <ProductImage>
        <img src={imageSrc} style={{ height: '70px', margin: 'auto', marginRight: '10px' }} alt=""/>
      </ProductImage>
      <Details>
        <Row>
          <Column style={{ flex: '1', alignItems: 'start' }}>
            <div style={{ color: '#565656', fontSize: '16px', minWidth: '100px' }}>{Name}</div>
            <div style={{ color: 'gray', fontSize: '12px', minWidth: '100px', fontStyle: 'italic', marginTop: '5px' }}>{Shipbob_SKU_Code__c}</div>
          </Column>
          <Column>
            <BigNumber className={IsGeneratedData ? 'IsGenerated' : ''} title={numHelp}>{Quantity || 0}</BigNumber>
            <div style={{ color: 'gray', fontSize: '12px' }}>Purchased</div>
          </Column>
          <Column>
            <div style={{ borderRight: 'solid 1px silver', minHeight: '30px' }}>&nbsp;</div>
          </Column>
          <Column>
            <TooltipWrapper text={fulfilledPopup}>
              <Column>
                <BigNumber className={IsGeneratedData ? 'IsGenerated' : ''} title={numHelp}>{IsGeneratedData ? '-' : fulfilled || 0}</BigNumber>
                <div style={{ color: 'gray', fontSize: '12px' }}>Fulfilled</div>
              </Column>
            </TooltipWrapper>
          </Column>
          <Column>
            <TooltipWrapper text={remainingPopup}>
              <Column>
                <BigNumber className={IsGeneratedData ? 'IsGenerated' : ''} title={numHelp}>{IsGeneratedData ? '-' : remaining || 0}</BigNumber>
                <div style={{ color: 'gray', fontSize: '12px' }}>Remaining</div>
              </Column>
            </TooltipWrapper>
          </Column>
        </Row>
      </Details>
    </Card>
  )
}